/* tslint:disable */
/* eslint-disable */
/**
 * /pharma-photo/product-image
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ProductImageSelectionOverviewResultsRestDto } from '../models';
import { ProductImageSelectionSettingsRestDto } from '../models';
/**
 * ImageSelectionSettingsAPIApi - axios parameter creator
 * @export
 */
export const ImageSelectionSettingsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint verantwoordelijk voor het ophalen van alle productafbeeldingen van een product met een overzicht van de afbeelding selectie die aangeeft welke al dan niet getoond dienen te worden in de catalogus.
         * @summary REST.API.PP.IMG.05 Toon alle productafbeeldingen voor product.
         * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductImageSelectionSettings: async (product_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'product_code' is not null or undefined
            if (product_code === null || product_code === undefined) {
                throw new RequiredError('product_code','Required parameter product_code was null or undefined when calling findProductImageSelectionSettings.');
            }
            const localVarPath = `/v1/product_image/{product_code}/selection_settings`
                .replace(`{${"product_code"}}`, encodeURIComponent(String(product_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint verantwoordelijk voor het wijzigen van de selectie settings voor productafbeeldingen van een product.
         * @summary REST.API.PP.IMG.06 Wijzig selectie settings voor productafbeeldingen van een product.
         * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
         * @param {ProductImageSelectionSettingsRestDto} [body] 
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductImageSelectionSettings: async (product_code: string, body?: ProductImageSelectionSettingsRestDto|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'product_code' is not null or undefined
            if (product_code === null || product_code === undefined) {
                throw new RequiredError('product_code','Required parameter product_code was null or undefined when calling syncProductImageSelectionSettings.');
            }
            const localVarPath = `/v1/product_image/{product_code}/selection_settings`
                .replace(`{${"product_code"}}`, encodeURIComponent(String(product_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageSelectionSettingsAPIApi - functional programming interface
 * @export
 */
export const ImageSelectionSettingsAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * API endpoint verantwoordelijk voor het ophalen van alle productafbeeldingen van een product met een overzicht van de afbeelding selectie die aangeeft welke al dan niet getoond dienen te worden in de catalogus.
         * @summary REST.API.PP.IMG.05 Toon alle productafbeeldingen voor product.
         * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProductImageSelectionSettings(_axios: AxiosInstance, product_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductImageSelectionOverviewResultsRestDto>> {
            const localVarAxiosArgs = await ImageSelectionSettingsAPIApiAxiosParamCreator(configuration).findProductImageSelectionSettings(product_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API endpoint verantwoordelijk voor het wijzigen van de selectie settings voor productafbeeldingen van een product.
         * @summary REST.API.PP.IMG.06 Wijzig selectie settings voor productafbeeldingen van een product.
         * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
         * @param {ProductImageSelectionSettingsRestDto} [body] 
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncProductImageSelectionSettings(_axios: AxiosInstance, product_code: string, body?: ProductImageSelectionSettingsRestDto|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ImageSelectionSettingsAPIApiAxiosParamCreator(configuration).syncProductImageSelectionSettings(product_code, body, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImageSelectionSettingsAPIApi - object-oriented interface
 * @export
 * @class ImageSelectionSettingsAPIApi
 * @extends {BaseAPI}
 */
export class ImageSelectionSettingsAPIApi extends BaseAPI {
    /**
     * API endpoint verantwoordelijk voor het ophalen van alle productafbeeldingen van een product met een overzicht van de afbeelding selectie die aangeeft welke al dan niet getoond dienen te worden in de catalogus.
     * @summary REST.API.PP.IMG.05 Toon alle productafbeeldingen voor product.
     * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageSelectionSettingsAPIApi
     */
     public findProductImageSelectionSettings(product_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImageSelectionSettingsAPIApiFp(this.configuration).findProductImageSelectionSettings(this.axios, product_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint verantwoordelijk voor het wijzigen van de selectie settings voor productafbeeldingen van een product.
     * @summary REST.API.PP.IMG.06 Wijzig selectie settings voor productafbeeldingen van een product.
     * @param {string} product_code The code that uniquely identifies a product. (Typically a CNK code or another key for products that do not have a CNK code.)
     * @param {ProductImageSelectionSettingsRestDto} [body] 
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer (API client ID).
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageSelectionSettingsAPIApi
     */
     public syncProductImageSelectionSettings(product_code: string, body?: ProductImageSelectionSettingsRestDto|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImageSelectionSettingsAPIApiFp(this.configuration).syncProductImageSelectionSettings(this.axios, product_code, body, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
